import {getPage} from '@packages/shared/utils/PageTreeUtils';
import {isBranchMergingRemotely} from '@packages/systems/designer/site-branch';
import {abilityFeature} from '../abilityFeature';

export const branchMergeLocked = abilityFeature({
  key: 'branchMergeLocked',
  isValid: function isBranchMergeLockedValid(state, expected) {
    if (!('BranchActivityStore' in state) || !('DesignerStore' in state)) {
      return expected === false;
    }

    const currentPage = getPage(
      state.DesignerStore?.currentPageId,
      state.PageStore
    );
    // A release's pages are not guaranteed to carry its id as `branchId`, so
    // the active release is matched directly.
    const activeSiteBranchId =
      'SiteBranchStore' in state
        ? state.SiteBranchStore?.activeSiteBranchId
        : null;
    const mergeEntry = state.BranchActivityStore?.branchMergeInProgress;
    const isMergingRemotely = [currentPage?.branchId, activeSiteBranchId].some(
      (branchId) => isBranchMergingRemotely(mergeEntry, branchId)
    );
    // The merge entry clears when the merge ends, but the lock holds until the
    // user has left the release.
    const isActiveSiteBranchMergedRemotely =
      'SiteBranchActivityStore' in state &&
      state.SiteBranchActivityStore?.activeSiteBranchMergedBy != null;

    return (isMergingRemotely || isActiveSiteBranchMergedRemotely) === expected;
  },
});
